import React, { useEffect, useRef, useState } from "react";
import { FiClock, FiHelpCircle } from "react-icons/fi";
import { TbDisc, TbWind } from "react-icons/tb";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import styles from "./ServiceCard.module.css";
import { Service } from "../types";
import { Slide } from "pure-react-carousel";
import { Toast } from "primereact/toast";
import useCartAPI from "../../../../api/useCartAPI";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateCartQuantity } from "../../../../features/cart/cartSlice";
interface ServiceCardProps {
  key?: string;
  service: Service;
  onSelectVehicle: (service: Service) => void;
  vehicleId: any;
  isShowPrice?: boolean;
}

export default function ServiceCard({
  service,
  onSelectVehicle,
  vehicleId,
  isShowPrice,
}: ServiceCardProps) {
  // console.log(vehicleId, "vehicleId");
  const toast = useRef<Toast>(null);
  const { cartSave, cartCount } = useCartAPI();
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isInCart, setIsInCart] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH;

  const [userId, setUserId] = useState<any>(null);
  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    setUserId(authTokens?.user?.id);
  }, []);
  const refreshCartCount = async () => {
    try {
      const payload = {
        is_wishList: false,
        is_user: true,
        product_id: 0,
        created_id: 0,
        service_id: 0,
        variant_id: 0,
      };

      const response: any = await cartCount(payload);

      if (response?.status === 200) {
        dispatch(updateCartQuantity(response?.data?.count ?? 0));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleGoToCart = () => {
    navigate(`${basePath}cart`);
  };
  const handleAddToCart = async () => {
    if (isAddingToCart) return;

    if (!userId) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Login",
      });
      return;
    }

    setIsAddingToCart(true);

    try {
      const payload = {
        service_id: (service as any)?.service_id,
        item_quantity: 1,
        is_wishList: false,
        vehicle_id: vehicleId,
      };

      // console.log(payload, "nautiyalLLLLLLLLLLLLLLLLLLLLL");
      const response: any = await cartSave(payload);
      // console.log(response, "nautiyalLLLLLLLLLLLLLLLLLLLLL");

      if (response?.status === 200 || response?.status === 201) {
        setIsInCart(true);

        await refreshCartCount();

        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: `${service.title} added to cart`,
        });
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Failed",
          detail: "Unable to add item to cart",
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Something went wrong. Please try again.",
      });
    } finally {
      setIsAddingToCart(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div id={`service-card-${service.id}`} className={styles.card}>
        <div className={styles.imageWrapper}>
          <img
            src={
              service.image ||
              "https://mechmiles.com/static/media/service-package-image.ba897500687564d5a162.png"
            }
            alt={service.title}
            className={styles.image}
            referrerPolicy="no-referrer"
          />
        </div>

        <div className={styles.content}>
          <div className={styles.headerRow}>
            <h3 className={styles.title}>{service.title}</h3>
          </div>

          <div className={styles.category}>{service.category}</div>

          <div className={styles.timeBadge}>
            <FiClock size={12} />
            <span>Approx time: {service.approxTime}</span>
          </div>

          <p className={styles.description}>{service.description}</p>

          <div className={styles.divider}></div>

          <div className={styles.footerRow}>
            {/* <div>
              <div className={styles.priceLabel}>Starting From</div>
              <div className={styles.priceValue}>
                ₹{service.offer_price?.toFixed(2)}
              </div>
            </div> */}
            <div>
              <div className={styles.priceLabel}>Starting From</div>
              <div className={styles.priceValue}>
                {!isShowPrice ? "₹ ***" : `₹${service.offer_price?.toFixed(2)}`}
              </div>
            </div>
            <button
              id={`select-btn-${service.id}`}
              className={isInCart ? styles.gotocart : styles.addToCart}
              onClick={isInCart ? handleGoToCart : handleAddToCart}
              disabled={isAddingToCart}
            >
              {isAddingToCart
                ? "Adding..."
                : isInCart
                  ? "GO TO CART"
                  : "ADD TO CART"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
